var $ = require('jquery');

$(function () {
    $('[data-new-grid-table]').each(function () {
        var currentPage,
            servicesFilters,
            industriesFilters,
            publicationsFilters,
            insightsSubjectsFilters,
            itemTypesFilters,
            locationsFilters,
            authorCategorizationFilters,
            makeRequest,
            getFilterValues,
            dateDesc,
            toggleClearLinkVisibility,
            clearLink,
            scrollToTop,
            uncheckAllFilterCheckboxes,
            clearAllFilters,
            filterDropdownCheckboxes;

        // settings
        var dateDesc = true;
        var apiUrlGetGrid = '/api/sitecore/FilteredGrid/GetGrid';
        // end settings
        var $this = $(this);
        var FilterCheckboxCollection = function () {
            return {
                services: null,
                industries: null,
                publications: null,
                insightsSubjects: null,
                itemTypes: null,
                locations: null,
                authorCategorization: null
            };
        }
        var $this = $(this);

        filterDropdownCheckboxes = new FilterCheckboxCollection();
        filterDropdownCheckboxes.services = $this.find('[data-services]');
        filterDropdownCheckboxes.industries = $this.find('[data-industries]');
        filterDropdownCheckboxes.publications = $this.find('[data-publications]');
        filterDropdownCheckboxes.insightsSubjects = $this.find('[data-insightssubjects]');
        filterDropdownCheckboxes.itemTypes = $this.find('[data-itemtypes]');
        filterDropdownCheckboxes.locations = $this.find('[data-locations]');
        filterDropdownCheckboxes.authorCategorization = $this.find('[data-authorcategorization]');

        var gridContainer = $this.find('[data-filtered-grid]');
        var datasourceId = $this.attr('data-context-item');
        var language = $this.attr('data-language');
        var isNormal = $this.attr('data-is-normal');

        clearLink = $this.find('[data-clear-filters]');


        // value to check in QS and append to Get URL
        var tagName = 'tagname';
        //page tagname querystring
        var tagNameQs = $.QueryString[tagName];
        // if tagNameQS is not empty or no value append it to the path of the url
        if (tagNameQs && tagNameQs != '') {
            apiUrlGetGrid = apiUrlGetGrid + '?' + tagName + '=' + tagNameQs;
        }

        currentPage = $this.find('.pagination .current').attr('data-page');

        var init = function () {
            servicesFilters = getFilterValues(filterDropdownCheckboxes.services);
            industriesFilters = getFilterValues(filterDropdownCheckboxes.industries);
            publicationsFilters = getFilterValues(filterDropdownCheckboxes.publications);
            insightsSubjectsFilters = getFilterValues(filterDropdownCheckboxes.insightsSubjects);
            itemTypesFilters = getFilterValues(filterDropdownCheckboxes.itemTypes);
            locationsFilters = getFilterValues(filterDropdownCheckboxes.locations);
            authorCategorizationFilters = getFilterValues(filterDropdownCheckboxes.authorCategorization);

            // Firefox preserves checkbox state on reload.
            uncheckAllFilterCheckboxes();
            clearAllFilters();

            clearLink.hide();
        }

        uncheckAllFilterCheckboxes = function () {
            $this.find('input[type=checkbox]:checked').each(function () {
                var $this = $(this);
                $this.removeAttr('checked');
                $this.prop('checked', false);
            });
        }
        clearAllFilters = function () {
            servicesFilters = [];
            industriesFilters = [];
            publicationsFilters = [];
            insightsSubjectsFilters = [];
            itemTypesFilters = [];
            locationsFilters = [];
            authorCategorizationFilters = [];
        }

        scrollToTop = function () {
            $('html, body').animate({
                scrollTop: $this.find('.grid-table-scrollTop').offset().top - 100
            }, 500);
        };

        makeRequest = function (targetServicesFilters,
            targetIndustriesFilters,
            targetPublicationsFilters,
            targetInsightsSubjectsFilters,
            targetItemTypesFilters,
            targetLocationsFilters,
            targetAuthorCategorizationFilters,
            targetPage, dateSortDesc) {
            var loadingElement = $this.find('.loading');
            loadingElement.addClass('show');
            $.ajax({
                type: 'GET',
                url: apiUrlGetGrid,
                traditional: true,
                data: {
                    id: datasourceId,
                    languageName: language,
                    servicesFilters: targetServicesFilters,
                    industriesFilters: targetIndustriesFilters,
                    publicationsFilters: targetPublicationsFilters,
                    insightsSubjectsFilters: targetInsightsSubjectsFilters,
                    itemTypesFilters: targetItemTypesFilters,
                    locationsFilters: targetLocationsFilters,
                    authorCategorizationFilters: targetAuthorCategorizationFilters,
                    page: targetPage,
                    isDateDesc: dateSortDesc,
                    enforceNormal: isNormal
                },
                success: function (data) {
                    gridContainer.empty();
                    gridContainer.html(data);

                    servicesFilters = targetServicesFilters;
                    industriesFilters = targetIndustriesFilters;
                    publicationsFilters = targetPublicationsFilters;
                    insightsSubjectsFilters = targetInsightsSubjectsFilters;
                    itemTypesFilters = targetItemTypesFilters;
                    locationsFilters = targetLocationsFilters;
                    authorCategorizationFilters = targetAuthorCategorizationFilters;

                    currentPage = targetPage;
                    dateDesc = dateSortDesc;
                    scrollToTop();
                    loadingElement.removeClass('show');
                },
                error: function () {
                },
                complete: function () {
                }
            });
        };

        gridContainer.on('click', '.pagination', function (e) {
            const targetPage = $(e.target).closest('[data-page]').data('page');
            if (Number.isInteger(targetPage) && targetPage !== currentPage) {
                //Enable when ready to use loading icon
                makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, targetPage, dateDesc);
            }
        });

        getFilterValues = function (element) {
            const checkboxes = element.find('input[type="checkbox"]');
            const filteredCheckboxes = checkboxes.filter(':checked');

            var ids = [];
            filteredCheckboxes.each(function () {
                ids.push($(this).attr('data-id'));
            });

            return ids;
        };


        toggleClearLinkVisibility = function () {
            if (!!getFilterValues(filterDropdownCheckboxes.services).length ||
                !!getFilterValues(filterDropdownCheckboxes.industries).length ||
                !!getFilterValues(filterDropdownCheckboxes.publications).length ||
                !!getFilterValues(filterDropdownCheckboxes.insightsSubjects).length ||
                !!getFilterValues(filterDropdownCheckboxes.itemTypes).length ||
                !!getFilterValues(filterDropdownCheckboxes.locations).length ||
                !!getFilterValues(filterDropdownCheckboxes.authorCategorization).length) {
                clearLink.show();
            } else {
                clearLink.hide();
            }
        };

        filterDropdownCheckboxes.services.on('click', 'input[type="checkbox"]', function () {
            makeRequest(getFilterValues(filterDropdownCheckboxes.services), industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            toggleClearLinkVisibility();
        });

        filterDropdownCheckboxes.industries.on('click', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, getFilterValues(filterDropdownCheckboxes.industries), publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            toggleClearLinkVisibility();
        });

        filterDropdownCheckboxes.publications.on('click', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, getFilterValues(filterDropdownCheckboxes.publications), insightsSubjectsFilters, itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            toggleClearLinkVisibility();
        });

        filterDropdownCheckboxes.insightsSubjects.on('click', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, getFilterValues(filterDropdownCheckboxes.insightsSubjects), itemTypesFilters, locationsFilters, authorCategorizationFilters, 0, dateDesc);
            toggleClearLinkVisibility();
        });

        filterDropdownCheckboxes.itemTypes.on('click', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, getFilterValues(filterDropdownCheckboxes.itemTypes), locationsFilters, authorCategorizationFilters, 0, dateDesc);
            toggleClearLinkVisibility();
        });

        filterDropdownCheckboxes.locations.on('click', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, getFilterValues(filterDropdownCheckboxes.locations), authorCategorizationFilters, 0, dateDesc);
            toggleClearLinkVisibility();
        });

        filterDropdownCheckboxes.authorCategorization.on('click', 'input[type="checkbox"]', function () {
            makeRequest(servicesFilters, industriesFilters, publicationsFilters, insightsSubjectsFilters, itemTypesFilters, locationsFilters, getFilterValues(filterDropdownCheckboxes.authorCategorization), 0, dateDesc);
            toggleClearLinkVisibility();
        });

        clearLink.on('click', function () {
            uncheckAllFilterCheckboxes();
            makeRequest(getFilterValues(filterDropdownCheckboxes.services), getFilterValues(filterDropdownCheckboxes.industries), getFilterValues(filterDropdownCheckboxes.publications), getFilterValues(filterDropdownCheckboxes.insightsSubjects), getFilterValues(filterDropdownCheckboxes.itemTypes), getFilterValues(filterDropdownCheckboxes.locations), getFilterValues(filterDropdownCheckboxes.authorCategorization), 0, dateDesc);
            toggleClearLinkVisibility();
        });

        init();
    });
});